var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQdrantLogoSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 346.42 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9e0d38;\n      }\n\n      .cls-2 {\n        fill: #dc244c;\n      }\n\n      .cls-3 {\n        fill: #ff516b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vectors"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.21 0 0 100 0 300 173.21 400 238.16 362.5 238.16 287.5 173.21 325 64.96 262.5 64.96 137.5 173.21 75 281.46 137.5 281.46 387.5 346.42 350 346.42 100 173.21 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "108.26 162.5 108.26 237.5 173.21 275 238.16 237.5 238.16 162.5 173.21 125 108.26 162.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "238.16 287.5 238.16 362.5 173.21 400 173.21 325 238.16 287.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "346.42 100 346.42 350 281.46 387.5 281.46 137.5 346.42 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "346.42 100 281.46 137.5 173.21 75 64.96 137.5 0 100 173.21 0 346.42 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.21 325 173.21 400 0 300 0 100 64.96 137.5 64.96 262.5 173.21 325"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "238.16 162.5 173.21 200 108.26 162.5 173.21 125 238.16 162.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.21 200 173.21 275 108.26 237.5 108.26 162.5 173.21 200"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "238.16 162.5 238.16 237.5 173.21 275 173.21 200 238.16 162.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQdrantLogoSvg);
export default __webpack_public_path__ + "static/media/qdrant_logo_svg.0b8cfe32f670f7ed8716e73a805c966b.svg";
export { ForwardRef as ReactComponent };